<template>
  <dv-full-screen-container>
    <div id="container">
      <div class="header">
        <div class="dp-center">
          <dv-decoration-6 style="width: 300px; height: 30px" />
          <h1>变压器数字孪生建模与故障预警</h1>
          <dv-decoration-6 style="width: 300px; height: 30px" />
        </div>
        <dv-decoration-5
          :color="['#7acaec', '#7acaec']"
          style="width: 300px; height: 40px"
        />
      </div>

      <div class="content">
        <div class="left panel">
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            :reverse="true"
            backgroundColor="#28f8ff12"
          >
            <BoxHeader :title="'变压器参数'" position="left" />
            <byq-component />
          </dv-border-box-4>
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            :reverse="true"
            backgroundColor="#28f8ff12"
          >
            <BoxHeader :title="'温度数字孪生预测'" position="left" />
            <line-chart-component ref="lineRef" @start="start" @end="end" />
          </dv-border-box-4>
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            :reverse="true"
            backgroundColor="#28f8ff12"
          >
            <BoxHeader :title="'温度全周期检测演示效果'" position="left" />
            <div style="height: calc(100% - 30px); padding: 5px 30px">
              <img src="../../assets/imgs/温度显示.gif" />
            </div>
          </dv-border-box-4>
        </div>
        <div class="center panel2">
          <dv-border-box-1
            backgroundColor="#28f8ff12"
            style="flex: 2 1 calc(100% - 290px)"
          >
            <model-component />
          </dv-border-box-1>

          <dv-border-box-1 backgroundColor="#28f8ff12" style="flex: 1 1 290px">
            <BoxHeader :title="'设备状态列表'" />
            <list-component ref="listRef" />
          </dv-border-box-1>
        </div>
        <div class="right panel">
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            backgroundColor="#28f8ff12"
          >
            <BoxHeader :title="'电流数据'" position="right" />
            <dl-chart-component />
          </dv-border-box-4>
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            backgroundColor="#28f8ff12"
          >
            <BoxHeader :title="'状态实时感知'" position="right" />
            <zt-component ref="ztRef" />
          </dv-border-box-4>
          <dv-border-box-4
            :color="['#7acaec', '#7acaec']"
            backgroundColor="#28f8ff12"
          >
            <status-component ref="statusRef" v-if="showStatusFlag" />
          </dv-border-box-4>
        </div>
      </div>
    </div>
  </dv-full-screen-container>
</template>

<script>
import "../../assets/js/noise.min";
import "../../assets/js/coalesce";
import BoxHeader from "../../components/BoxHeader.vue";
import ByqComponent from "./components/byq-component.vue";
import ZtComponent from "./components/zt-component.vue";
import StatusComponent from "./components/status-component.vue";
import ListComponent from "./components/list-component.vue";
import ModelComponent from "./components/model-component.vue";
import lineChartComponent from "./components/line-chart-component.vue";
import DlChartComponent from "./components/dl-chart-component.vue";
export default {
  components: {
    BoxHeader,
    ByqComponent,
    ZtComponent,
    StatusComponent,
    ListComponent,
    ModelComponent,
    lineChartComponent,
    DlChartComponent,
  },
  data() {
    return {
      showStatusFlag: true,
      statusArr: ["优", "异常"],
      colorArr: ["#0ff", "red"],
      currentIndex: 1,
      timer: "",
    };
  },
  methods: {
    start() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.statusRef.title = this.statusArr[1];
          this.$refs.statusRef.color = this.colorArr[1];
          this.$refs.statusRef.initChart();

          //  切换状态
          this.$refs.listRef.errorFlag = true;
          this.$refs.ztRef.errorFlag = true;
        });
      }, 60000);
    },
    end() {
      if (this.timer) clearTimeout(this.timer);
      this.$nextTick(() => {
        this.currentIndex = 0;
        this.$refs.statusRef.title = this.statusArr[this.currentIndex];
        this.$refs.statusRef.color = this.colorArr[this.currentIndex];
        this.$refs.statusRef.initChart();
        if (this.currentIndex >= 1) this.currentIndex = 0;
        else this.currentIndex++;

        //  切换状态
        this.$refs.listRef.errorFlag = false;
        this.$refs.ztRef.errorFlag = false;
      });
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a0e3ff;
  letter-spacing: 0.5rem;
  text-shadow: 0px 7px 10px #ace6ff;
  margin-right: 30px;
  margin-left: 30px;
}
canvas {
  position: unset !important;
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}
.header > h1 {
  margin-bottom: 0;
}
.content {
  height: calc(100vh - 125px);
  display: flex;
}
.panel {
  flex: 1;
}
.panel2 {
  flex: 1.5;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.left,
.right {
  display: flex;
  flex-direction: column;
}

img {
  height: 100%;
  width: 100%;
}
</style>
